import React from "react";
import { FaCheck } from "react-icons/fa";

export const Timeline = ({ currentStep }) => {
  return (
    <div className="timeline-checkout flex-container font13-5-semibold font15 flex-center align-center">
      <div className={`timeline-item ${currentStep >= 1 ? "completed" : ""}`}>
        {currentStep > 1 ? <FaCheck size={9} /> : <span>1</span>}
      </div>
      <div className="timeline-line"></div>
      <div className={`timeline-item ${currentStep >= 2 ? "completed" : ""}`}>
        {currentStep > 2 ? <FaCheck size={9} /> : <span>2</span>}
      </div>
      <div className="timeline-line"></div>
      <div className={`timeline-item ${currentStep >= 3 ? "completed" : ""}`}>
        {currentStep === 3 ? <FaCheck size={9} /> : <span>3</span>}
      </div>
    </div>
  );
}